import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const API_URL = "https://comoticket-production.up.railway.app/api";

const fmtDate = (d) => d ? new Date(d).toLocaleDateString("fr-FR", {weekday:"long", day:"numeric", month:"long", year:"numeric", hour:"2-digit", minute:"2-digit"}) : "-";

export default function VerifyTicketPage() {
  const { reference } = useParams();
  const navigate = useNavigate();
  const [input, setInput] = useState(reference || "");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleVerify = async (ref) => {
    const r = ref || input;
    if (!r.trim()) return;
    setLoading(true); setError(""); setResult(null);
    try {
      const res = await fetch(API_URL + "/public/verify/" + encodeURIComponent(r.trim()));
      const data = await res.json();
      if (!res.ok) { setError(data.error || "Billet introuvable"); }
      else { setResult(data); }
    } catch(e) {
      setError("Erreur de connexion au serveur");
    } finally { setLoading(false); }
  };

  React.useEffect(() => { if (reference) handleVerify(reference); }, []);

  const statusColor = result ? (result.status === "sold" ? "#10b981" : result.status === "used" ? "#f59e0b" : "#ef4444") : "#gray";
  const statusLabel = result ? (result.status === "sold" ? "Valide" : result.status === "used" ? "D&eacute;j&agrave; utilis&eacute;" : "Invalide") : "";
  const statusIcon = result ? (result.status === "sold" ? "&#9989;" : result.status === "used" ? "&#9888;" : "&#10060;") : "";

  return (
    <div style={{minHeight:"100vh",background:"#0a0a0a",fontFamily:"'Inter',Arial,sans-serif",color:"white"}}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap'); * { box-sizing:border-box; margin:0; padding:0; }`}</style>
      <nav style={{position:"sticky",top:0,zIndex:100,background:"rgba(10,10,10,0.95)",backdropFilter:"blur(20px)",borderBottom:"1px solid rgba(255,255,255,0.06)",padding:"16px 40px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <a href="/events" style={{display:"flex",alignItems:"center",gap:10,textDecoration:"none"}}>
          <div style={{width:36,height:36,background:"#2563eb",borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,fontWeight:800,color:"white"}}>C</div>
          <span style={{fontSize:18,fontWeight:800,letterSpacing:"-0.5px",color:"white"}}>ComoTicket</span>
        </a>
        <span style={{fontSize:13,color:"rgba(255,255,255,0.5)"}}>V&eacute;rification de billet</span>
      </nav>

      <div style={{maxWidth:520,margin:"0 auto",padding:"60px 24px"}}>
        <div style={{textAlign:"center",marginBottom:40}}>
          <div style={{fontSize:48,marginBottom:16}}>&#128203;</div>
          <h1 style={{fontSize:28,fontWeight:900,letterSpacing:"-1px",marginBottom:8}}>V&eacute;rifier un billet</h1>
          <p style={{fontSize:14,color:"rgba(255,255,255,0.5)"}}>Entrez la r&eacute;f&eacute;rence de votre billet pour v&eacute;rifier sa validit&eacute;</p>
        </div>

        <div style={{background:"#111",borderRadius:16,padding:24,border:"1px solid rgba(255,255,255,0.06)",marginBottom:24}}>
          <label style={{fontSize:12,fontWeight:600,color:"rgba(255,255,255,0.5)",display:"block",marginBottom:8}}>R&eacute;f&eacute;rence du billet</label>
          <div style={{display:"flex",gap:10}}>
            <input
              value={input}
              onChange={e => setInput(e.target.value.toUpperCase())}
              onKeyDown={e => e.key === "Enter" && handleVerify()}
              placeholder="Ex: VT12345"
              style={{flex:1,padding:"12px 16px",background:"rgba(255,255,255,0.05)",border:"1.5px solid rgba(255,255,255,0.1)",borderRadius:10,color:"white",fontSize:16,fontFamily:"monospace",fontWeight:700,letterSpacing:2,outline:"none"}}
            />
            <button onClick={() => handleVerify()} disabled={loading} style={{padding:"12px 20px",background:"#2563eb",border:"none",color:"white",borderRadius:10,fontWeight:700,fontSize:14,cursor:"pointer",opacity:loading?0.7:1}}>
              {loading ? "..." : "V&eacute;rifier"}
            </button>
          </div>
          {error && <div style={{marginTop:12,color:"#fca5a5",fontSize:13,background:"rgba(239,68,68,0.1)",padding:"8px 12px",borderRadius:8}}>{error}</div>}
        </div>

        {result && (
          <div style={{background:"#111",borderRadius:16,overflow:"hidden",border:"2px solid " + statusColor}}>
            <div style={{background:statusColor,padding:"20px 24px",display:"flex",alignItems:"center",gap:12}}>
              <span style={{fontSize:32}} dangerouslySetInnerHTML={{__html: statusIcon}} />
              <div>
                <div style={{fontSize:20,fontWeight:900,color:"white"}} dangerouslySetInnerHTML={{__html: statusLabel}} />
                <div style={{fontSize:13,color:"rgba(255,255,255,0.8)"}}>R&eacute;f: #{result.sale_reference}</div>
              </div>
            </div>
            {result.event_image && <img src={result.event_image} alt={result.event_name} style={{width:"100%",height:160,objectFit:"cover"}} />}
            <div style={{padding:24}}>
              <h2 style={{fontSize:20,fontWeight:800,marginBottom:16}}>{result.event_name}</h2>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                {[
                  {label:"Date", value:fmtDate(result.event_date)},
                  {label:"Lieu", value:result.location},
                  {label:"Porteur", value:result.holder_name || "-"},
                  {label:"Cat&eacute;gorie", value:result.category_name},
                ].map((item, i) => (
                  <div key={i} style={{background:"rgba(255,255,255,0.03)",borderRadius:10,padding:12}}>
                    <div style={{fontSize:11,color:"rgba(255,255,255,0.4)",marginBottom:4}} dangerouslySetInnerHTML={{__html:item.label}} />
                    <div style={{fontSize:14,fontWeight:600}}>{item.value}</div>
                  </div>
                ))}
              </div>
              {result.qr_url && (
                <div style={{textAlign:"center",marginTop:20}}>
                  <img src={result.qr_url} alt="QR Code" style={{width:140,height:140,borderRadius:12,border:"4px solid " + statusColor}} />
                </div>
              )}
            </div>
          </div>
        )}

        <div style={{textAlign:"center",marginTop:32,fontSize:12,color:"rgba(255,255,255,0.2)"}}>
          ComoTicket &mdash; Syst&egrave;me de billetterie s&eacute;curis&eacute;
        </div>
      </div>
    </div>
  );
}